import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { TRIP_EXPENSE_PATH } from '../../config/paths';
import { isErrorResponse } from '../../utils/error-handlers';
import { TRIP_EXPENSE_ENDPOINT } from '../../config/endpoints';
import {
  CLEAR_TRIP_EXPENSE,
  CLEAR_TRIP_EXPENSES,
  FLAG_TRIP_EXPENSE_ACTIVITY,
  FLAG_GETTING_TRIP_EXPENSES,
  GET_TRIP_EXPENSE,
  GET_TRIP_EXPENSES,
} from '../types';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';

const flagGettingTripExpenses = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_TRIP_EXPENSES,
    payload: flag,
  });

const getTripExpenses = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingTripExpenses(true));
    const query = tableFilters;
    const url = `${TRIP_EXPENSE_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const detractions = await response.json();
    dispatch({
      type: GET_TRIP_EXPENSES,
      payload: detractions,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingTripExpenses(false));
  }
};

const clearTripExpenses = () => (dispatch) =>
  dispatch({
    type: CLEAR_TRIP_EXPENSES,
  });

const flagTripExpenseActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_TRIP_EXPENSE_ACTIVITY,
    payload: flag,
  });

const getTripExpense =
  async ({ tripExpenseId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTripExpenseActivity(true));
      const url = `${TRIP_EXPENSE_ENDPOINT}/${tripExpenseId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const detraction = await response.json();
      dispatch({
        type: GET_TRIP_EXPENSE,
        payload: detraction,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagTripExpenseActivity(false));
    }
  };

const clearTripExpense = () => (dispatch) =>
  dispatch({
    type: CLEAR_TRIP_EXPENSE,
  });

const postTripExpense =
  async ({
    countryCode,
    detractionRate,
    minTripExpenseAmount,
    detractionCode,
    bankAccountNumber,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagTripExpenseActivity(true));
      const payload = {
        countryCode,
        detractionRate,
        minTripExpenseAmount,
        detractionCode,
        bankAccountNumber,
      };
      const url = TRIP_EXPENSE_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const detraction = await response.json();
      dispatch(push(`${TRIP_EXPENSE_PATH}/${detraction.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagTripExpenseActivity(false));
    }
  };

const putTripExpense =
  async (
    tripExpenseId,
    {
      countryCode,
      detractionRate,
      minTripExpenseAmount,
      detractionCode,
      bankAccountNumber,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagTripExpenseActivity(true));
      const payload = {
        id: tripExpenseId,
        countryCode,
        detractionRate,
        minTripExpenseAmount,
        detractionCode,
        bankAccountNumber,
      };
      const url = `${TRIP_EXPENSE_ENDPOINT}/${tripExpenseId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const detraction = await response.json();
      dispatch(push(`${TRIP_EXPENSE_PATH}/${detraction.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagTripExpenseActivity(false));
    }
  };

const deleteTripExpense =
  async ({ tripExpenseId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTripExpenseActivity(true));
      const url = `${TRIP_EXPENSE_ENDPOINT}/${tripExpenseId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response;
      dispatch(push(TRIP_EXPENSE_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagTripExpenseActivity(false));
    }
  };


export {
  flagGettingTripExpenses,
  getTripExpenses,
  clearTripExpenses,
  getTripExpense,
  clearTripExpense,
  postTripExpense,
  putTripExpense,
  deleteTripExpense,
};
